import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Box
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddBasicDetails from './AddBasicDetails';

const NomineeAccordion = ({
  nominee,
  setNominee,
  errors,
  handleUpload,
  onPanBlur,
  relationList,
  today,
  age,
  index,
  removeNominee,
  handleAllocationChange,
  beneficiary,
  beneficiaryList,
  selectedBeneficiary,
  handleSelectChange,
  insuranceType,
  selectedNominee
}) => {
  return (
    <>
    <Accordion sx={{ marginBottom: '1rem' }} key={index} defaultExpanded={index === 0}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`nominee-content-${index}`}
        id={`nominee-header-${index}`}
      >
        <Typography>{`Nominee ${index + 1}`}</Typography>
      </AccordionSummary>
      <AccordionDetails>
          {beneficiaryList && beneficiaryList.length > 0  && (
            <FormControl fullWidth sx={{ mb: '1rem', width: '99%' }}>
              <InputLabel id="nominee-select-label">Existing Users</InputLabel>
              <Select
                labelId={`nominee-select-label-${index}`}
                id={`nominee-select-${index}`}
                value={beneficiary.nominee_details[index].id || ''}
                label="Select Nominee"
                onChange={(event) => handleSelectChange(event, 'nominee', index)}
              >
                {beneficiaryList
                  .filter((nominee) => {
                    if (insuranceType === 'Staff Insurance') {
                      return nominee.relation !== 'Employee';
                    }
                    // Default filtering
                    if (index === 0) {
                      return nominee.id !== selectedBeneficiary;
                    } else if (index === 1) {
                      return nominee.id !== selectedBeneficiary && nominee.id !== beneficiary.nominee_details[0]?.id;
                    }
                    return true;
                  })
                  .map((nominee, idx) => (
                    <MenuItem key={idx} value={nominee.id}>
                      {nominee.first_name}
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          )}
          <AddBasicDetails
            stateType={nominee}
            setStateType={(updatedNominee) => setNominee(updatedNominee)}
            errors={errors}
            handleUpload={(e) => handleUpload(e, (updatedNominee) => setNominee(updatedNominee))}
            onPanBlur={(e) => onPanBlur(e, (updatedNominee) => setNominee(updatedNominee))}
            relationList={relationList}
            today={today}
            age={age}
          />
          <FormControl sx={{ width: '49%', my: 2, mr: '1%' }}>
            <InputLabel>Allocation Percentage</InputLabel>
            <Select
              label="Allocation Percentage"
              value={beneficiary.nominee_details[index].allocation_percent}
              onChange={(e) => handleAllocationChange(index, e)}
              name="allocation_percent"
              disabled={index === 1 && beneficiary.nominee_details[index].allocation_percent === 50}
            >
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </FormControl>
        <Box>
        </Box>
        
      </AccordionDetails>
    </Accordion>
    <Button
      variant="contained"
      color="primary"
      onClick={() => removeNominee(index)}
      sx={{marginBottom: 2}}
    >
      Remove Nominee {index+1}
    </Button>
    </>
  );
};

export default NomineeAccordion;
